<template>
  <div v-for="projectDeveloper in application.projectDevelopers"
       :key="projectDeveloper.id"
       class="mb-4">
    <h4 class="tab__content__title">{{ $lang.app.PLANNER_INFORMATION }}</h4>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.TYPE }}</span>
      <span class="stack__value">{{ $lang.app[userTypesGetLabelRefByValue(projectDeveloper.type)] }}</span>
    </div>

    <template v-if="projectDeveloper.type === userTypesGetValueByKey('INDIVIDUAL_ENTITY')
        || projectDeveloper.type === userTypesGetValueByKey('INDIVIDUAL_ENTREPRENEUR')">
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.PIN }}</span>
        <span class="stack__value">{{ projectDeveloper.person?.pin }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.SURNAME }}</span>
        <span class="stack__value">{{ projectDeveloper.person?.surname }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.NAME }}</span>
        <span class="stack__value">{{ projectDeveloper.person?.name }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.PATRONYMIC }}</span>
        <span class="stack__value">{{ projectDeveloper.person?.patronymic }}</span>
      </div>
    </template>

    <template v-if="projectDeveloper.type === userTypesGetValueByKey('LEGAL_ENTITY')">
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.INN }}</span>
        <span class="stack__value">{{ projectDeveloper.organization?.inn }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.ORG_NAME_KG }}</span>
        <span class="stack__value">{{ projectDeveloper.organization?.nameKg }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.ORG_NAME_RU }}</span>
        <span class="stack__value">{{ projectDeveloper.organization?.nameRu }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.ORG_CHIEF_SURNAME }}</span>
        <span class="stack__value">{{ projectDeveloper.organization?.surname }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.ORG_CHIEF_NAME }}</span>
        <span class="stack__value">{{ projectDeveloper.organization?.name }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.ORG_CHIEF_PATRONYMIC }}</span>
        <span class="stack__value">{{ projectDeveloper.organization?.patronymic }}</span>
      </div>
    </template>

    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.CERTIFICATE_NUMBER }}</span>
      <span class="stack__value">{{ projectDeveloper.certNumber }}</span>
    </div>
    <div v-if="projectDeveloper.files" class="stack__list">
      <span class="stack__label">{{ $lang.app.FILE_CERTIFICATE_LICENSES }}</span>
      <span class="stack__value cursor-pointer"
            @click="loadProjectDeveloperFile(projectDeveloper, projectDeveloper.files)">{{ projectDeveloper.files.filename }}</span>
    </div>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.PHONE }}</span>
      <span class="stack__value">{{ projectDeveloper.phoneNumber }}</span>
    </div>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.EMAIL }}</span>
      <span class="stack__value">{{ projectDeveloper.email }}</span>
    </div>

    <div v-for="architect in projectDeveloper.projectArchitects"
         :key="architect.id"
         class="my-4">

      <h4 class="tab__content__title">{{ $lang.app.PROJECT_MAIN_ARCHITECT }}</h4>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.SURNAME }}</span>
        <span class="stack__value">{{ architect.surname }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.NAME }}</span>
        <span class="stack__value">{{ architect.name }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.PATRONYMIC }}</span>
        <span class="stack__value">{{ architect.patronymic }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.CERTIFICATE_NUMBER }}</span>
        <span class="stack__value">{{ architect.certNumber }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.PHONE }}</span>
        <span class="stack__value">{{ architect.phoneNumber }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.EMAIL }}</span>
        <span class="stack__value">{{ architect.email }}</span>
      </div>
    </div>

    <div v-for="engineer in projectDeveloper.projectEngineers"
         :key="engineer.id"
         class="my-4">
      <h4 class="tab__content__title">{{ $lang.app.PROJECT_MAIN_ENGINEER }}</h4>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.SURNAME }}</span>
        <span class="stack__value">{{ engineer.surname }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.NAME }}</span>
        <span class="stack__value">{{ engineer.name }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.PATRONYMIC }}</span>
        <span class="stack__value">{{ engineer.patronymic }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.CERTIFICATE_NUMBER }}</span>
        <span class="stack__value">{{ engineer.certNumber }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.PHONE }}</span>
        <span class="stack__value">{{ engineer.phoneNumber }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.EMAIL }}</span>
        <span class="stack__value">{{ engineer.email }}</span>
      </div>
    </div>

  </div>
</template>
<script>
import {
  getValueByKey as userTypesGetValueByKey,
  getLabelRefByValue as userTypesGetLabelRefByValue,
} from "../../../helpers/constants/userTypes";
import applicationApi from "../../../api/employee/application";

export default {
  props: {
    application: Object
  },
  methods: {
    userTypesGetValueByKey,
    userTypesGetLabelRefByValue,
    loadProjectDeveloperFile(projectDeveloper, file) {
      this.$emitter.emit('open-loader-modal')
      applicationApi
          .getProjectDeveloperFile(this.application.id, projectDeveloper.id, file.id)
          .then((response) => {
            this.$emitter.emit('open-file-modal', response.data)
          })
          .catch((error) => {
            this.$snotify.error(error);
          })
          .finally(() => {
            this.$emitter.emit('close-loader-modal')
          });
    },
  }
}
</script>